import React, { FC } from "react";
import PippaBotWrapper from "@app/pippa/components/pippaBotWrapper";
import SessionInactivityWatcher from "@app/pippa/components/sessionInactivityWatcher";
import { SessionProvider } from "@app/pippa/session";
import {
  APIProvider,
  DialogsProvider,
  EventsProvider,
} from "@app/pippa/provider";

const Pippa: FC = () => {
  return (
    <SessionProvider>
      <APIProvider>
        <DialogsProvider>
          <EventsProvider>
            <SessionInactivityWatcher />
            <PippaBotWrapper />
          </EventsProvider>
        </DialogsProvider>
      </APIProvider>
    </SessionProvider>
  );
};

export default Pippa;
